<div class="editor-block-text editor-block-video" [class.active]="active" [class.inactive]="!active" (click)="emitActive()">

  <div class="position-relative image-wrap" (click)="unfocusEditor()">
    <!-- placeholder -->
    @if (!hasFile()) {
      <div class="editor-image-placeholder" style="border-radius: 3px;border-bottom-left-radius: 0;border-bottom-right-radius: 0;" (click)="openAddVideoLinkModal()">
        <img src="/assets/img/editor/block-video-placeholder.svg" style="width: 602px; height: auto;" draggable="false">
        <span>Voeg video toe</span>
      </div>
    }
    <!-- preview -->
    @if (fileId && getDraftFile()) {
      <img class="editor-image-preview" style="width: 602px; height: auto; float: left; border-radius: 3px;border-bottom-left-radius: 0;border-bottom-right-radius: 0;"
        draggable="false"
        [ngfSrc]="getDraftFile()">
    }
    <!-- blob urls -->
    @if (fileId && getFile()) {
      <img class="editor-image-preview" style="width: 602px; height: auto; float: left; border-radius: 3px;border-bottom-left-radius: 0;border-bottom-right-radius: 0;"
        draggable="false"
        [src]="getFile().blobUrl">
    }

    @if (hasFile() && active) {
      <div class="editor-image-overlay d-flex align-items-center justify-content-center">
        <span (click)="openAddVideoLinkModal()"><i class="icon icon-image-edit"></i></span>
        <span (click)="removeFile.emit(fileId); urlChange.emit('')"><i class="icon icon-image-delete"></i></span>
      </div>
    }
    @if (hasFile() && url && active) {
      <a class="editor-image-overlay--url" [href]="url">{{url}}</a>
    }
  </div>

  <div class="w-100" style="padding-top: 20px;padding-left: 24px;padding-right: 24px;">

    <!-- edit -->
    <div class="display-hide" [class.d-block]="active">
      <quill-editor
        (onEditorCreated)="editorCreated($event)"
        customToolbarPosition="bottom"
        placeholder="Schrijf hier je tekst..."
        [modules]="modules"
        [(ngModel)]="model"
        (onContentChanged)="onChange($event)"
        >
        <div quill-editor-toolbar>
          <span class="ql-formats">
            <button class="ql-header" value="1"></button>
            <button class="ql-header" value="2"></button>
            <button class="ql-bold" [title]="''"></button>
            <button class="ql-italic"></button>
            <button class="ql-underline"></button>
            <select class="ql-align" [title]="'Aligment'">
              <option selected></option>
              <option value="center"></option>
              <option value="right"></option>
              <option value="justify"></option>
            </select>
            <button (click)="openLinkModal()" id="link-button"><i class="im-icon im-icon-link"></i></button>
            <!-- <button class="ql-link"></button> -->
            <button class="ql-list" value="ordered"></button>
            <button class="ql-list" value="bullet"></button>
            <button class="ql-indent" value="-1"></button>
            <button class="ql-indent" value="+1"></button>
            <button class="ql-script" value="sub"></button>
            <button class="ql-script" value="super"></button>
            <button class="ql-clean"></button>
          </span>
        </div>
      </quill-editor>
    </div>

    <!-- view -->
    @if (!active) {
      <div style="pointer-events: none;" [innerHtml]="sanitizer.bypassSecurityTrustHtml(model)" class="ql-output"></div>
      @if (!active && !model) {
        <div style="pointer-events: none;" class="editor-emptystate">Schrijf hier je tekst...</div>
      }
    }
  </div>

</div>